export default __webpack_public_path__ + "static/media/ic_namibia.deddc9c0.svg";